import { render, staticRenderFns } from "./Preparacion.vue?vue&type=template&id=f45ca146"
import script from "./Preparacion.vue?vue&type=script&lang=js"
export * from "./Preparacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports